import { ChangeDetectionStrategy, Component, DestroyRef, computed, inject, input, output, signal } from '@angular/core';
import { CHAT_DELAY_MS } from '../../types/constants';

@Component({
  selector: 'app-chat-input-row',
  templateUrl: './chat-input-row.component.html',
  styleUrls: [
    './chat-input-row.component.css',
    './chat-input-row.component.mobile.css',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatInputRowComponent {
  readonly placeholder = input.required<string>();
  // 'glass' = the battle overlay's translucent material; geometry is shared.
  readonly variant = input<'default' | 'glass'>('default');

  readonly send = output<string>();

  readonly text = signal('');
  private readonly cooldown = signal(false);
  private cooldownTimer: ReturnType<typeof setTimeout> | null = null;

  readonly armed = computed(() => this.text().trim().length > 0 && !this.cooldown());

  constructor() {
    inject(DestroyRef).onDestroy(() => {
      if (this.cooldownTimer) clearTimeout(this.cooldownTimer);
    });
  }

  onSubmit(event: Event) {
    event.preventDefault();
    const message = this.text().trim();
    if (!message || this.cooldown()) return;
    this.send.emit(message);
    this.text.set('');
    this.cooldown.set(true);
    this.cooldownTimer = setTimeout(() => {
      this.cooldownTimer = null;
      this.cooldown.set(false);
    }, CHAT_DELAY_MS);
  }
}
